import { render, staticRenderFns } from "./truckoil.vue?vue&type=template&id=65598782&"
import script from "./truckoil.vue?vue&type=script&lang=js&"
export * from "./truckoil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports